import { ActionContext, Module } from 'vuex'
import { AuthUser, User } from '../models'
import { RootState, UserState } from '@/store/state_models'

import LogsService from '@/services/LogsService'
import { User as UserApi } from '../models/api'
import { UsersService } from '../services'
import Vue from 'vue'
import defaults from '@/config'
import firebase from 'firebase/compat/app'
import localStorage from 'store'
import moment from 'moment'
import router from '../routes/index'
import { transformUserApiData } from '../util/helper'

let unsubscribe: () => void
export const user: Module<UserState, RootState> = {
  namespaced: true,
  state: {
    passwordUpdatedInOnboarding: false,
    internalUser: false,
    scopes:[],
    scopesAssignedOnly: [],
  },
  // getters: {
  //   getPermission: (
  //     state: UserState,
  //     getters: any,
  //     rootState: RootState,
  //     rootGetters: any
  //   ) => (locationId: string) => {
  //     if (locationId && state.user.locationPermissions) {
  //       const locationSpecificPermission = state.user.locationPermissions
  //       if (locationSpecificPermission[locationId]) {
  //         return locationSpecificPermission[locationId]
  //       }
  //     }
  //     return state.user.permissions
  //   },
  // },
  getters: {
    get: (state: UserState) => {
			return state.user;
    },
		isAdminUser: (state: UserState) => {
			return ['admin', 'agency'].includes(state?.user?.role)
		},
    getScopes: (state: UserState) => {
			return state.scopes || [];
    },
    getScopesAssignedOnly: (state: UserState) => {
      return state.scopesAssignedOnly || [];
    }
	},
  mutations: {
    set: (state: UserState, payload: object) => {
      Vue.set(state, 'user', payload)
      if (payload?.['platformLanguage']) window.localStorage.setItem('locale', payload['platformLanguage'])
    },
    updatePasswordUpdatedInOnboarding(state: UserState, payload: boolean) {
      console.log('updatePasswordUpdatedInOnboarding', payload)
      state.passwordUpdatedInOnboarding = payload
    },
    setInternalUser(state: UserState, payload: boolean) {
      state.internalUser = payload
    },
    setUserData(state: UserState, userData: { [key: string]: any}) {
      state.scopes = userData.scopes
      state.scopesAssignedOnly = userData.scopesAssignedOnly
    }
  },
  actions: {
    get: {
      handler: async (context: ActionContext<UserState, RootState>) => {
        if (context.state.user) {
          return context.state.user
        }
        try {
          const credentials = new AuthUser(
            await context.dispatch('auth/get', null, { root: true })
          )
          const user = await UserApi.getById(credentials.userId)
          const userData = transformUserApiData(user.data);
          const data = { ...userData, id: user.id }
          context.commit('set', data)
          context.commit('setUserData', userData);
          return data
        } catch (err) {
          console.error('Store/User: GET:', err)
          console.error(typeof err)
          const currentUser = firebase.auth().currentUser
          if (currentUser) {
            const token = await currentUser.getIdToken()
            console.error('Store/User: GET: Token', token)
            // if (token) {
            //   const values = atob(token)
            //   console.error(values)
            // }
          }
          // missing or insufficient permissions handler
          if (err.message === 'Missing or insufficient permissions.') {
            let authState, authLocalStorage, firebaseToken, claims

            try {
              authState = await context.dispatch('auth/get', null, { root: true })
              authLocalStorage = JSON.parse(atob(localStorage.get('a')))
              // console.log('authState', authState, authLocalStorage)
              if (authState?.userId && authLocalStorage?.userId && authState?.userId !== authLocalStorage?.userId) {
                console.log('Reloading page as userID different in state and storage')
                window.location.reload()
                return
              }
            } catch (error) {
              console.error('Error while state and localstorage user check',error)
            }

            // Gather Firebase token and claims for logging
            try {
              firebaseToken = await firebase?.auth()?.currentUser?.getIdToken()
              // Get Firebase token claims safely
              if (firebaseToken) {
                try {
                  const decodedToken = await firebase?.auth()?.currentUser?.getIdTokenResult()
                  claims = decodedToken
                } catch (claimsErr) {
                  console.warn('Store/User: GET > Failed to decode Firebase token claims:', claimsErr)
                }
              }
            } catch(err) {
              console.error('Error while getting firebase token and claims', err)
            }

            try {
              // Send comprehensive error details to logging service
              await LogsService.dump('frontend-logout', {
                instance: 'Global Permissions error handler',
                origin: 'Store/User: GET',
                event: {
                  message: err?.message,
                  code: err?.code,
                  stack: err?.stack,
                },
                page: window?.location?.href,
                route: {
                  name: router.currentRoute.name,
                  fullPath: router.currentRoute.fullPath
                },
                firebaseClaims: claims?.claims,
                firebaseToken,
                firebaseTokenMeta: {
                  issuedAt: claims?.issuedAtTime,
                  expirationTime: claims?.expirationTime
                }
              })
            } catch(err) {
              console.error('Error while logging firebase token and claims', err)
            }

            console.log('Error while auth/get in store - firebase auth.')
            try {
              router.push({ name: 'login', params: { logout: 'true' } })
              await context.dispatch('logout')
              try {
                firebase.auth().signOut()
              } catch (err) {
                console.error(
                  'Error while auth/get in store - firebase auth.',
                  err
                )
              }
              try {
                await context.dispatch('auth/signOutFromBackend', null, { root: true })
              } catch (err) {
                console.error(
                  'Error while auth/get in store - axios signout.',
                  err
                )
              }

              // Clear all the cookies and localostorage
              document.cookie.split(';').forEach(function (c) {
                document.cookie = c
                  .replace(/^ +/, '')
                  .replace(
                    /=.*/,
                    '=;expires=' + new Date().toUTCString() + ';path=/'
                  )
              })
              window.localStorage.clear()

              // Clear the Indexed DB
              if (window.indexedDB) {
                const dbs = [
                  'firebase-installations-database',
                  'firebaseLocalStorageDb',
                  'firebase-messaging-database',
                ]
                dbs.forEach(db => {
                  window.indexedDB.deleteDatabase(db)
                })
              }
              document.getElementById('app')?.classList.remove('loading')
            } catch (err) {
              console.error('Error while auth/get in store.', err)
            }
          }
        }
      },
    },
    syncAll: {
      root: true,
      handler: async (context: ActionContext<UserState, RootState>) => {
        let credentials: AuthUser
        try {
          credentials = new AuthUser(
            await context.dispatch('auth/get', null, { root: true })
          )
        } catch (e) {
          return
        }

        unsubscribe = User.getStreamById(credentials.userId).onSnapshot(
          async (snapshot: firebase.firestore.DocumentSnapshot) => {
            let data = snapshot.data()
            // to get default permissions enforced in getter

            const user = await UserApi.getById(credentials.userId)
            const userData = transformUserApiData(user.data)
            const {permissions, scopes, scopesAssignedOnly} = new User(userData)
            data.permissions = permissions
            data.scopes = scopes
            data.scopesAssignedOnly = scopesAssignedOnly

            let logoutDueToInvalidity = false
            let logoutDueToPasswordChange = false
            if (data && (data.last_password_change || data.last_force_logout)) {
              const loginDateFromStorage = localStorage.get('loginDate')
              if (!loginDateFromStorage) {
                logoutDueToPasswordChange = true
              } else {
                const loginDate = moment(loginDateFromStorage)
                const lastPasswordChange = data.last_password_change ? moment(data.last_password_change.toMillis()) : null
                const lastForceLogout = data.last_force_logout ? moment(data.last_force_logout.toMillis()) : null
                if (
                  loginDate &&
                  lastPasswordChange &&
                  loginDate.isBefore(lastPasswordChange)
                ) {
                  if (!context.state.passwordUpdatedInOnboarding) {
                    console.log(
                      'Logging out due to password change',
                      loginDate,
                      lastPasswordChange
                    )
                    logoutDueToPasswordChange = true
                  }
                }
                if (
                  loginDate &&
                  lastForceLogout &&
                  loginDate.isBefore(lastForceLogout)
                ) {
                  logoutDueToInvalidity = true
                }
              }
            }

            const internalUser = localStorage && localStorage.get('app_referer') === defaults.supportPortalUrl
            if (internalUser) context.commit('setInternalUser', true);
            if (!internalUser && data && !data.last_login_time) {
              logoutDueToPasswordChange = true
            }

            const isProxyUser = await context.rootGetters['auth/isProxyUser']
            if (isProxyUser) {
              logoutDueToPasswordChange = false
              logoutDueToInvalidity = false
            }

            if (data?.restrictSubAccount && (data?.role === User.TYPE_AGENCY && !data?.isAgencyOwner)) {
              const currentLocationId = router?.currentRoute?.params?.location_id || ""
              if (currentLocationId && !(Object.keys(data?.locations || {}).includes(currentLocationId))) {
                router.push({ name: 'dashboard', replace: true })
              }
            }

            if (
              !data ||
              data.deleted === true ||
              (!data.isAgencyOwner && !data.is_active) ||
              (context.state &&
                context.state.user &&
                context.state.user.role !== data.role) ||
              logoutDueToPasswordChange ||
              logoutDueToInvalidity
            ) {
              try {
                if(isProxyUser){
                  const recentlyVisitedUsers = localStorage.get('recentlyVisitedUsers') || {};
                  delete recentlyVisitedUsers[snapshot.id]
                  localStorage.set('recentlyVisitedUsers', recentlyVisitedUsers)
                  await context.dispatch('auth/switchToMasterUser', null, { root: true })
                  return;
                }
                await context.dispatch('auth/signOutFromBackend', null, { root: true })
                await context.dispatch('logout', null, { root: true })
                firebase.auth().signOut()
                router.push('/')
              } catch (err) {
                console.error(err)
              }
            }
            context.commit('set', { ...data, id: snapshot.id })
            try {
              if (data.scopes) {
                context.commit('setUserData', data);

              } else {
                await context.dispatch('setUserData')
              }
            } catch (error) {
              console.error('Error while setting user data', error)
            }
          },
          async error => {
            console.error('Store/User: SyncAll', error)
            console.error(typeof error)

            try {
              let token, userState, role, type, locationCount
              try {
                token = await firebase?.auth()?.currentUser?.getIdToken()
                userState = await context.dispatch('user/get', null, { root: true })
                role = userState?.role
                type = userState?.type
                locationCount = Object.keys(userState?.locations)?.length
              } catch(err) {}
              await LogsService.dump('frontend-logout', { instance: 'Store/User: SyncAll', error, page: window?.location?.href, authState: credentials, firebaseToken: token, role, type, locationCount })
            } catch(err) {}

            try {
              const token = await firebase?.auth()?.currentUser?.getIdToken()
              console.error('Store/User: FB currentUser IdToken', token)
            } catch {
              console.error('Store/User: FB currentUser while getting token')
            }
          }
        )
      },
    },
    deleteUserState: {
      handler: (context: ActionContext<UserState, RootState>) => {
        context.commit('set', undefined)
      },
    },
    setUserData: {
      handler: async (context: ActionContext<UserState, RootState>) => {
        const userData = await UsersService.read(context.state.user.id);
        context.commit('setUserData', userData);
      },
    },
    logout: {
      root: true,
      handler: async (context: ActionContext<UserState, RootState>) => {
        context.dispatch('deleteUserState')
        if (unsubscribe) {
          unsubscribe()
        }
        if (window && window.pendo) {
          window.pendo.clearSession();
        }
      },
    },
    update: {
			handler: (context: ActionContext<UserState, RootState>, payload: object): Promise<UserState | undefined> => {
				return new Promise(async (resolve, reject) => {
					try {
					const userData = transformUserApiData(payload);
          context.commit('set', userData)
					resolve(userData);
					} catch (e) {
						reject();
					}
				});
			},
		},
  },
}

